
const desktopRoundUp = (total: number, isDesktop: boolean) => {
    if (!isDesktop) {
        return total;
    }

    //total should be even number
    return total % 2 === 0 ? total : total + 1;
}

export const getNumberOfGoodsToDisplay = (
    initialNumber: number,
    indexOfThirdUnselectedGood: number,
    isDesktop: boolean = false
): number => {
    // Start with initial number
    const numberOfGoods = indexOfThirdUnselectedGood + 1;

    if (numberOfGoods < initialNumber) {
        return initialNumber;
    }

    return desktopRoundUp(numberOfGoods, isDesktop);
};

